export default "__VITE_ASSET__BAPTlmXZ__"